import OrderBaseReq from "./OrderBaseReq";

export default class CreateOrderReq extends OrderBaseReq {}
